import { PropertyPathWalker } from './PropertyPathWalker.js';
import { TypeKind } from '../types.js';
import { SourceUtils } from './SourceUtils.js';
import { ModelSystemProperties } from '../internal/ModelSystemProperties.js';
export class PropertyValueIterable {
    constructor(schema, model, path) {
        this.schema = schema;
        this.index = 0;
        const walker = new PropertyPathWalker(path, schema, model, ModelSystemProperties.getTypeRef(model));
        const propertyValue = walker.getPropertyValue();
        let propertyType = this.schema.getType(propertyValue.property.type);
        if (propertyType.kind === TypeKind.Enum) {
            this.values = propertyType.values;
        }
        else {
            let sourceUtils = new SourceUtils(schema);
            this.values = sourceUtils.getPropertySources(model, path);
        }
    }
    next() {
        if (this.values && this.values.length > this.index) {
            let val = this.values[this.index];
            this.index++;
            return val;
        }
    }
}
//# sourceMappingURL=PropertyValueIterable.js.map